"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lessThanEqualMatcherContext = void 0;
function lessThanEqualMatcherContext(ruleAttr) {
    return function lessThanEqualMatcher(runtimeAttr) {
        var isLessThanEqual = runtimeAttr <= ruleAttr;
        return isLessThanEqual;
    };
}
exports.lessThanEqualMatcherContext = lessThanEqualMatcherContext;
